import { Action, createReducer, on } from '@ngrx/store'
import * as LegacyActions from './legacy.actions'
import { initialState, State } from './legacy.state.facade'

const legacyReducer = createReducer(
  initialState,

  on(LegacyActions.setSelectedProgram, (state, { clientId, yearId, programId }) => ({
    ...state,
    selectedClientId: clientId,
    selectedYearId: yearId,
    selectedProgramId: programId,
    // A structure belongs to a program, so keep it only while the same program
    // stays selected; clearing or changing the program drops the structure.
    selectedStructureId:
      programId && programId === state.selectedProgramId ? state.selectedStructureId : null,
  })),

  on(LegacyActions.setSelectedStructure, (state, { structureId }) => ({
    ...state,
    selectedStructureId: structureId,
  })),

  on(LegacyActions.clearSelectedProgram, (state) => ({
    ...state,
    selectedClientId: null,
    selectedYearId: null,
    selectedProgramId: null,
    selectedStructureId: null,
    clientName: null,
    yearLabel: null,
    programName: null,
  })),

  on(LegacyActions.setActiveContextNames, (state, { clientName, yearLabel, programName }) => ({
    ...state,
    clientName,
    yearLabel,
    programName,
  })),

  on(LegacyActions.activeContextLoaded, (state, { clientId, yearId, programId, structureId }) => ({
    ...state,
    selectedClientId: clientId,
    selectedYearId: yearId,
    selectedProgramId: programId,
    selectedStructureId: structureId,
    contextLoaded: true,
  })),

  on(LegacyActions.markActiveContextLoaded, (state) => ({
    ...state,
    contextLoaded: true,
  })),
)

export function reducer(state: State | undefined, action: Action): State {
  return legacyReducer(state, action)
}
